/**
 * The context fields `clearSolutionScope` resets when the address no longer names
 * the solution in context: the handles that name the solution the user left, plus
 * the one loaded slice whose page would not reload it on re-entry
 * (`defaultMessagesPypes`). Every other loaded slice is left to its own reload.
 */
export const clearedSolutionScope = () => ({
  botId: undefined,
  botName: undefined,
  botIdURLParam: undefined,
  channelId: undefined,
  selectedBot: undefined,
  // PSTUDIO-4449: without this, coming back to the same solution pairs it with
  // the draft id kept from the previous visit until loadBotVersions resolves.
  solutionVersionPsSolutionId: null,
  // PSTUDIO-4553: `loadDefaultMessages` reads the channels of the solution in ctx
  // and the page loads once, while this is null, so a copy kept from the solution
  // the user left would be shown (and saved to) under the next one.
  defaultMessagesPypes: null,
});
